<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش قالب های پیام</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-btn color="secondary" style="letter-spacing: normal">
              موجودی :
              {{
                formatRial(credit)
              }}
            </v-btn>

          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="messages"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.status`]="{ item }">
                <v-switch v-model="item.status" label="وضعیت" @change="changeStatus(item)" :true-value="1"
                          :false-value="0"></v-switch>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/sms/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="success" @click="$router.push('/sms/get/'+item.id)">mdi-eye</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SmsIndexView",
  data() {
    return {
      loading: true,
      credit: null,
      messages: {},
      headers: [
        {text: 'لیبل', value: 'label', align: 'center'},
        {text: 'متن', value: 'content', align: 'center'},
        {text: 'وضعیت', value: 'status', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getMessages()
  },
  methods: {
    formatRial(value) {
      return new Intl.NumberFormat('fa-IR', { style: 'currency', currency: 'IRR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);    },
    getMessages() {
      let url = 'message/sms/index'
      window.axios.get(url).then((res) => {
        this.messages = res.data.data.templates
        this.credit = res.data.data.credit
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    changeStatus(item) {
      console.log(item)
      window.axios.post('message/sms/update/' + item.id, {
        content: item.content,
        status: item.status,
      }).then(() => {
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style scoped>

</style>